/**
 * Проверяет, что с момента *lastTimestamp* прошло *interval* времени
 * @param lastTimestamp - timestamp (e.g. Date.now)
 * @param interval - время в миллисекундах
 */
export const checkTimeInterval = (lastTimestamp: string | null, interval: number) => {
    if (lastTimestamp) {
        const diff = Date.now() - Number.parseInt(lastTimestamp);
        return diff < interval;
    }
    return false;
};
